import * as actions from './actions';

export default {
  ...actions,
};